import { Modal } from 'antd'
import React from 'react'
import LoginModal from './LoginModal';
import VerificationBySmsModal from './VerificationBySmsModal';
import { useAuthModalStore } from 'modules/zustand/store';
import { CFCDN } from 'modules/shop-front/shop-front-component/ProductCollection';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import forgotPassword from '../forgot-password';
import ChangePasswordModal from './ChangePasswordModal';

export default function ModalAuth() {

    const windowWidth = window.innerWidth;
    const getModalWidth = () => {
        if (windowWidth >= 768) { // md breakpoint
        return '1000px'; // Width for medium screens and up
        }
        return ''; // Full width for smaller screens
    };
    const loginModal = useAuthModalStore((state)=> state.loginModal)
    const secureModal = useAuthModalStore((state)=> state.secureModal)
    const setOffLoginModal = useAuthModalStore((state)=>state.setOffLoginModal)
    const setOffSecureModal = useAuthModalStore((state)=>state.setOffSecureModal)

    const registerModal = useAuthModalStore((state)=>state.registerModal)
    const setOffRegisterModal = useAuthModalStore((state)=>state.setOffRegisterModal)

    const forgotModal = useAuthModalStore((state)=>state.forgotModal)
    const setOffForgotModal = useAuthModalStore((state)=>state.setOffForgotModal)

    const passwordModal = useAuthModalStore((state)=>state.passwordModal)
    const setOffPasswordModal = useAuthModalStore((state)=>state.setOffPasswordModal)

    const setPasswordToken = useAuthModalStore((state)=>state.setPasswordToken)
    const setUserSub = useAuthModalStore((state)=>state.setUserSub)

    return (
        <div >
            <Modal width={getModalWidth()} open={loginModal} footer={null}  onCancel={setOffLoginModal} centered  >
           
                <div className='flex flex-row gap-5 my-1'>
                    <div className="hidden lg:block relative rounded-md  bg-neutral-500 overflow-hidden flex items-center justify-center ">
                        <div className="absolute bottom-0 from-black  w-full h-full bg-gradient-to-t opacity-80"></div>
                        <div className='absolute bottom-1/2  transform flex flex-col items-center w-full'>
                            <span className="text-white text-4xl font-bold hedvig-letters-serif-regular text-center px-10 ">Shading Solutions, <i>Designed</i> <br></br>for You.</span>
                        </div>
                        
                        <img
                            src={CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg"}
                            alt="Centered Image"
                            className="object-center object-cover w-full h-full"
                        /> 
                    
                    </div>
                    <LoginModal ></LoginModal>
                    
                </div>
            

        </Modal>
        <Modal width={getModalWidth()} open={secureModal} footer={null} onCancel={setOffSecureModal} centered>
            
                <div className='flex flex-row gap-5 my-1'>
                    <div className="hidden lg:block relative rounded-md  bg-neutral-500 overflow-hidden flex items-center justify-center ">
                        <div className="absolute bottom-0 from-black  w-full h-full bg-gradient-to-t opacity-80"></div>
                        <div className='absolute bottom-1/2  transform flex flex-col items-center w-full'>
                        <span className="text-white text-4xl font-bold hedvig-letters-serif-regular text-center px-10 ">Shading Solutions, <i>Designed</i> <br></br>for You.</span>
                        </div>
                        
                        <img
                            src={CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg"}
                            alt="Centered Image"
                            className="object-center object-cover w-full h-full"
                        /> 
                    
                    </div>
                    <VerificationBySmsModal></VerificationBySmsModal>
                
                </div>
            
                
        </Modal>
        <Modal width={getModalWidth()} open={registerModal} footer={null} onCancel={setOffRegisterModal} centered>
            
                <div className='flex flex-row gap-5 my-1'>
                    <div className="hidden lg:block relative rounded-md  bg-neutral-500 overflow-hidden flex items-center justify-center ">
                        <div className="absolute bottom-0 from-black  w-full h-full bg-gradient-to-t opacity-80"></div>
                        <div className='absolute bottom-1/2  transform flex flex-col items-center w-full'>
                        <span className="text-white text-4xl font-bold hedvig-letters-serif-regular text-center px-10 ">Shading Solutions, <i>Designed</i> <br></br>for You.</span>
                        </div>
                        
                        <img
                            src={CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg"}
                            alt="Centered Image"
                            className="object-center object-cover w-full h-full"
                        /> 
                    
                    </div>
                    <RegisterModal></RegisterModal>
                
                </div>
            
                
        </Modal>
        <Modal width={getModalWidth()} open={forgotModal} footer={null} onCancel={setOffForgotModal} centered>
            
                <div className='flex flex-row gap-5 my-1'>
                    <div className="hidden lg:block relative rounded-md  bg-neutral-500 overflow-hidden flex items-center justify-center ">
                        <div className="absolute bottom-0 from-black  w-full h-full bg-gradient-to-t opacity-80"></div>
                        <div className='absolute bottom-1/2  transform flex flex-col items-center w-full'>
                        <span className="text-white text-4xl font-bold hedvig-letters-serif-regular text-center px-10 ">Shading Solutions, <i>Designed</i> <br></br>for You.</span>
                        </div>
                        
                        <img
                            src={CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg"}
                            alt="Centered Image"
                            className="object-center object-cover w-full h-full"
                        /> 
                    
                    </div>
                    <ForgotPasswordModal></ForgotPasswordModal>
                
                </div>
            
                
        </Modal>

        <Modal width={getModalWidth()} open={passwordModal} footer={null} onCancel={()=>{setOffPasswordModal();setPasswordToken('');setUserSub('');}}  centered>
            
                <div className='flex flex-row gap-5 my-1'>
                    <div className="hidden lg:block relative rounded-md  bg-neutral-500 overflow-hidden flex items-center justify-center ">
                        <div className="absolute bottom-0 from-black  w-full h-full bg-gradient-to-t opacity-80"></div>
                        <div className='absolute bottom-1/2  transform flex flex-col items-center w-full'>
                        <span className="text-white text-4xl font-bold hedvig-letters-serif-regular text-center px-10 ">Shading Solutions, <i>Designed</i> <br></br>for You.</span>
                        </div>
                        
                        <img
                            src={CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg"}
                            alt="Centered Image"
                            className="object-center object-cover w-full h-full"
                        /> 
                    
                    </div>
                    <ChangePasswordModal></ChangePasswordModal>
                
                </div>
            
                
        </Modal>
        </div>
        
    )
}
